import { render, staticRenderFns } from "./ClienteServico.vue?vue&type=template&id=7d8a5132"
import script from "./ClienteServico.vue?vue&type=script&lang=js"
export * from "./ClienteServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports